import _keyBy from "lodash/keyBy";
import _mapValues from "lodash/mapValues";
import { OptionData } from "src/components/molecules/OptionList/types";
import { ReactSelectSearchItem } from "src/globalTypes";
import {
  NotificationsSubscription,
  SubscriptionTemplate,
} from "src/requests/notifications/types";
import { SubscriptionIds } from "./types";

const mapToOptions = (
  subscription: SubscriptionTemplate
): ReactSelectSearchItem => ({
  value: String(subscription.templateId),
  name: subscription.templateName,
  text: subscription.templateName,
  label: subscription.templateName,
});

export const mapOptionToId = (option: OptionData) => Number(option.value);

export const getSubscriptionOptionsById = (
  subscriptions: NotificationsSubscription
) => {
  if (!subscriptions) return {};

  const { subscribed, unsubscribed } = subscriptions;

  const subscriptionsById = _keyBy(
    [...subscribed, ...unsubscribed],
    ({ templateId }) => templateId
  );
  const subscriptionOptionsById = _mapValues(subscriptionsById, mapToOptions);

  return subscriptionOptionsById;
};

const getOnlySubscriptionIds = (
  subscription: SubscriptionTemplate[] | undefined
) => {
  if (!subscription) return [];

  return subscription.map(({ templateId }) => String(templateId));
};

export const getSubscriptionsIds = (
  subscriptions: NotificationsSubscription
): SubscriptionIds => ({
  subscribed: getOnlySubscriptionIds(subscriptions.subscribed),
  unsusbscribed: getOnlySubscriptionIds(subscriptions.unsubscribed),
});

export const getNewValues = (
  newArr: string[] | number[],
  baseArr: string[] | number[]
): number[] => {
  const numberNewArr = newArr.map(Number);
  const numberBaseArr = baseArr.map(Number);

  return numberNewArr.filter((value) => !numberBaseArr.includes(value));
};
